import EditDeviceContent from "./EditDeviceContent";

export default EditDeviceContent;